export const SELLER_INVOICES_PAGE = 'seller-invoices-page';
export const REGISTER_LAYOUT_HEADER_MIGRATION =
  'supply_seller_ui_header_migration';
export const AR_IMAGES_MATH_CHECK = 'cnl_ar_images_math_check';
export const AR_IMAGES_MATH_CHECK_ENABLED = 'cnl_ar_images_math_check_enabled';
